import { dayMonthTime } from '@core/ui/RuDates';

/**
 * Как назвать документ, который кладут в дело.
 *
 * Правила те же, что в `DocumentImports` Android-версии, и это самое важное место
 * всего продукта: без названия в деле окажется та же папка с `IMG_3847`, ради ухода
 * от которой приложение и делается.
 */

/** У файла с устройства имя уже есть — расширение из него убираем. */
export function titleOf(fileName: string): string {
  const dot = fileName.lastIndexOf('.');
  const name = dot > 0 ? fileName.slice(0, dot) : fileName;

  return name.trim().length > 0 ? name.trim() : fileName;
}

/**
 * «Потом» — полноценный ответ: в суде на именование может не быть времени.
 *
 * Документ получает пометку с датой и временем, чтобы в списке было видно, к чему
 * вернуться: «Не разобрано — 5 сентября, 14:30».
 */
export const unsortedTitle = (at: Date): string => `Не разобрано — ${dayMonthTime(at)}`;

/** Название, если его назвали; иначе пометка «Не разобрано». */
export const titleOrUnsorted = (title: string | null, at: Date): string => {
  const trimmed = title?.trim() ?? '';

  return trimmed.length > 0 ? trimmed : unsortedTitle(at);
};

/** Имя файла в хранилище для снятого: у снимка своего имени нет. */
export const photoFileName = (index = 0): string =>
  index > 0 ? `photo-${index}.jpg` : 'photo.jpg';
